var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22166_86299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15032 19.0254C7.36985 18.9603 7.60522 18.9842 7.81266 19.0811C9.63131 19.931 11.7264 20.2037 13.7491 19.8475C15.8917 19.4702 17.8068 18.4132 19.1374 16.8734C20.4679 15.3337 21.1232 13.4163 20.9809 11.4789C20.8386 9.54141 19.9085 7.71606 18.3641 6.34315C16.8196 4.97024 14.7662 4.14348 12.5866 4.017C10.4071 3.89053 8.25016 4.47297 6.51803 5.65575C4.78589 6.83853 3.59676 8.54091 3.17235 10.4455C2.77986 12.2068 3.06611 14.0298 3.97666 15.6231C4.11707 15.8688 4.15235 16.1637 4.05257 16.4285L3.03852 19.1198C2.99445 19.2373 2.98806 19.3633 3.02005 19.4838C3.05204 19.6043 3.12116 19.7145 3.21966 19.8021C3.31816 19.8897 3.44214 19.9511 3.57771 19.9795C3.71328 20.008 3.85509 20.0023 3.98723 19.9631L7.15032 19.0254Z",
    stroke: "white",
    strokeWidth: 1.77777,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22166_86299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIcon);
export default __webpack_public_path__ + "static/media/comments-icon.2cca5a368ecaa62e554746627bd613ab.svg";
export { ForwardRef as ReactComponent };